import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fleetOnlyAccountSchema } from '../schemas/fleet-only-account.schema';
import { z } from 'zod/v4';
import { fromFetch } from 'rxjs/fetch';

/**
 * Retrieves fleet only accounts for the current account
 * @returns A response object containing an array of fleet only accounts
 */
export function getAccountsFleetOnlyEnabled(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).accountsFleetOnlyEnabledUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(
    selectData(
      z.object({
        accounts: z.array(fleetOnlyAccountSchema),
      })
    )
  );
}
